import { CiMoneyBill } from "react-icons/ci";

import { Button } from "@/components/ui/button/button";
import { useEmpLoanModal } from "./use-loan-modal";
import { EmployeeLoanModal } from "./emp-loan-modal";

export const EmployeeLoan = () => {
  const { onOpenChange } = useEmpLoanModal();

  return (
    <div className="w-60 h-24 rounded-md bg-card flex flex-col justify-between gap-1 shadow-sm border p-3">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">Employee Loan</h2>

        <CiMoneyBill className="w-4 h-4" />
      </div>
      <div className="">
        <Button
          variant="default"
          size="sm"
          onClick={() => {
            onOpenChange(true);
          }}
        >
          View
        </Button>
      </div>

      <EmployeeLoanModal />
    </div>
  );
};
